import { useEffect, useState } from "react";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { useVisitorData } from "@fingerprint/react";
import {
  GlobalProvider,
  useThemeContext,
} from "./globalContext/global-context";
import { supportsSurveyQuestion } from "./questions/registry";
import { SurveySession } from "./session/SurveySession";
import {
  createBrowserSurveyTransport,
  type HttpSurveyTransport,
} from "./session/transport";
import { SurveyAppShell } from "./shell/SurveyAppShell";

const theme = createTheme({
  palette: { mode: "light", primary: { main: "#49AE8A" } },
});

function SurveyApp(): React.ReactElement {
  const { globalObject } = useThemeContext();
  const copy = globalObject.themeData.normalizedTheme.copy;
  const [runtime, setRuntime] = useState<{
    session: SurveySession;
    transport: HttpSurveyTransport;
  } | null>(null);
  const { data: visitorData } = useVisitorData({ immediate: true });
  const sealedResult = visitorData?.sealed_result?.base64();

  useEffect(() => {
    const transport = createBrowserSurveyTransport(copy);
    const session = new SurveySession(
      transport,
      undefined,
      supportsSurveyQuestion,
      copy,
    );
    setRuntime({ session, transport });
    session.start();
    return () => session.dispose();
  }, [copy]);

  useEffect(() => {
    if (!runtime || !sealedResult) return;
    void runtime.transport.loginVisitor(sealedResult).catch(console.error);
  }, [runtime, sealedResult]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {runtime && <SurveyAppShell session={runtime.session} />}
    </ThemeProvider>
  );
}

function App(): React.ReactElement {
  return (
    <GlobalProvider>
      <SurveyApp />
    </GlobalProvider>
  );
}

export default App;
